import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Login Redux States
import { CHECK_LOGIN, LOGOUT_USER } from './actionTypes';
import { apiError, loginUserSuccessful, logoutUserSuccess } from './actions';

// AUTH related methods - Using real API instead of fake backend
import { loginUser, logoutUser as logoutUserAPI } from '../../../helpers/auth_helper';
import { getFirebaseBackend } from '../../../helpers/firebase_helper';

//Initilize firebase
const fireBaseBackend = getFirebaseBackend();

//If user is login then dispatch redux action's are directly from here.
function* loginUserSaga({ payload: { user, history } }) {
    try {
        console.log('Login saga started with payload:', { user, history });

        if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
            console.log('Using Firebase authentication');
            const response = yield call(fireBaseBackend.loginUser, user.username, user.password);
            yield put(loginUserSuccessful(response));
        }
        else {
            console.log('Using real API authentication');
            console.log('Calling loginUser with:', { email: user.username, password: user.password });

            // Using real API endpoint
            const response = yield call(loginUser, {
                email: user.username,
                password: user.password
            });

            console.log('Login API response:', response);

            // Store user data and token in localStorage
            if (response.token) {
                localStorage.setItem("authUser", JSON.stringify(response.user));
                localStorage.setItem("authToken", response.token);
                console.log('User data and token stored in localStorage');
            } else {
                localStorage.setItem("authUser", JSON.stringify(response));
                console.log('User data stored in localStorage (no token)');
            }

            yield put(loginUserSuccessful(response));
        }

        // Navigate to dashboard after successful login
        if (history && typeof history === 'function') {
            console.log('Navigating to categories');
            history('/categories');
        } else {
            console.error('History function not available:', history);
        }
    } catch (error) {
        console.error('Login saga error:', error);
        console.error('Error details:', {
            message: error.message,
            stack: error.stack,
            response: error.response
        });
        yield put(apiError(error.message || 'Login failed'));
    }
}

function* logoutUserSaga({ payload: { history } }) {
    try {
        localStorage.removeItem("authUser");
        localStorage.removeItem("authToken");

        if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
            const response = yield call(fireBaseBackend.logout);
            yield put(logoutUserSuccess(response));
        } else {
            // Call logout API if needed
            try {
                yield call(logoutUserAPI);
            } catch (error) {
                console.log('Logout API error:', error);
            }
            yield put(logoutUserSuccess({}));
        }

        // Navigate to login after logout
        if (history && typeof history === 'function') {
            history('/login');
        }
    } catch (error) {
        yield put(apiError(error));
    }
}

export function* watchUserLogin() {
    yield takeEvery(CHECK_LOGIN, loginUserSaga);
}

export function* watchUserLogout() {
    yield takeEvery(LOGOUT_USER, logoutUserSaga);
}

function* loginSaga() {
    yield all([
        fork(watchUserLogin),
        fork(watchUserLogout),
    ]);
}

export default loginSaga;